//Core
import React from "react"

//Components
import Seo from "../../container/Layout/Seo"
import Credit from "../../modules/credit"

//Styles
// import "../../styles/main.scss"

const CreditPage = () => {
  return (
    <>
      <Seo
        title={`Кредитні канікули | ТАСКОМБАНК`}
        description={`Залиште заявку на кредитні канікули за кредитами готівкою та беззаставними кредитами`}
        link={`https://tascombank.ua/promo/kreditni-kanikuli/`}
      ></Seo>
      <Credit></Credit>
    </>
  )
}

export default CreditPage
